import SubscribeButton from "./subscribe_button";
import AddToCartButton from "./add_cart_button";
import SubscribeFreeButton from "./subscribe_free_button";
import {CartButton, CartAnmButton} from "./cart_button";
import {getAppTheme, getCatalogBtn} from "./helper/helpers";
import {CatalogContext} from "./catalog_context";
import useToggleCart from "./hooks/useToggleCart";

const catalogData = catalogModule.catalogData;
const AddonButton = (props) => {
    const appTheme = getAppTheme();
    const productButton = getCatalogBtn();
    let product = props.product;
    let button;
    const hasOwnedPckg = catalogData.hasOwnProperty("owned_package_key") && catalogData.owned_package_key.indexOf("plan") > 0;
    const hasOwnedPckgInfo = catalogData.hasOwnProperty("owned_package_info") && catalogData.owned_package_info.hasOwnProperty("key") && catalogData.owned_package_info.key.indexOf("plan") > 0;
    // const [formData, setFormData] = React.useState({
    //     product: product.key,
    //     product_key: product.key
    // });
    // const [isLoading, setIsLoading] = React.useState(false);
    // const [formAttr, setFormAttr] = React.useState({
    //     text: addCartText,
    //     btn: `${productButton}`,
    //     form: `add_from_cart`,
    //     url: addCartUrl,
    //     status: "add"
    // });

    // const toggleCart = (e) => {
    //     let tempFormAttr = Object.assign({}, formAttr);
    //     setIsLoading(true);
    //     if(tempFormAttr.status === "add"){
    //         sendAjaxPostJson(
    //             formData,
    //             addCartUrl,
    //             function (data) {
    //                 $.unblockUI();
    //                 if (data.result === "ok") {
    //                     if(typeof purpose === "undefined"){
    //                         purpose = data.purpose;  // #93144
    //                     }
    //
    //                     window.dataLayer.push({ ecommerce: null });
    //                     window.dataLayer.push({
    //                         'event': 'add_to_cart',
    //                         'ecommerce': {
    //                             'currencyCode': 'EUR',
    //                             'add': {
    //                                 'products': [{
    //                                     'id': product.key,
    //                                     "name": product.name,
    //                                     "price": product.price,
    //                                     "category": product.type,
    //                                     "quantity": 1
    //                                 }]
    //                             }
    //                         }
    //                     });
    //
    //                     tempFormAttr.text = removeCartText;
    //                     tempFormAttr.btn = `${productButton} added`;
    //                     tempFormAttr.form = "remove_from_cart";
    //                     tempFormAttr.url = removeCartUrl;
    //                     tempFormAttr.status = "remove";
    //                     setFormAttr(tempFormAttr);
    //                     setIsLoading(false);
    //                     catalogModule.addInCart(formData.product);
    //                     if(catalog_data.app_theme === "manager" && props.page === "create"){
    //                         if(props.onAddToCart){
    //                             props.onAddToCart(formData.product_key);
    //                         }
    //                     }
    //                     if(CartUIRender){
    //                         CartUIRender.updateCartNum("increase");
    //                     }
    //                 } else {
    //                     if (data.message && data.message.length > 0) {
    //                         showAndScrollErrorMessage(false, $("#products-page-error-msg"), data.message, null, false);
    //                     } else {
    //                         if (data.error) {
    //                             showGenericMessage("Message", data.error);
    //                         } else {
    //                             showAndScrollErrorMessage(false, $("#products-page-error-msg"),
    //                                 gettext("Couldn't process request. Please contact support."), null, false);
    //                         }
    //                     }
    //                 }
    //             },
    //             false
    //         );
    //     } else {
    //         sendAjaxPostJson(
    //             formData,
    //             removeCartUrl,
    //             function (data) {
    //                 $.unblockUI();
    //                 if (data.result === "ok") {
    //                     if(typeof purpose !== "undefined"){
    //                         purpose = data.purpose;  // refresh the purpose #93144
    //                     }
    //                     window.dataLayer.push({ ecommerce: null });
    //                     window.dataLayer.push({
    //                         'event': 'remove_from_cart',
    //                         'ecommerce': {
    //                             'remove': {
    //                                 'products': [{
    //                                     'id': product.key
    //                                 }]
    //                             }
    //                         }
    //                     });
    //
    //                     tempFormAttr.text = addCartText;
    //                     tempFormAttr.btn = `${productButton}`;
    //                     tempFormAttr.form = "add_from_cart";
    //                     tempFormAttr.url = addCartUrl;
    //                     tempFormAttr.status = "add";
    //                     setFormAttr(tempFormAttr);
    //                     setIsLoading(false);
    //                     catalogModule.removeInCart(formData.product);
    //                     if(catalog_data.app_theme === "manager" && props.page === "create"){
    //                         if(props.onRemoveToCart){
    //                             props.onRemoveToCart(formData.product_key);
    //                         }
    //                     }
    //                     if(CartUIRender){
    //                         CartUIRender.updateCartNum("decrease");
    //                     }
    //                 } else {
    //                     showAndScrollErrorMessage(false, $("#products-page-error-msg"),
    //                         gettext("Couldn't process request. Please contact support."), null, false);
    //                 }
    //             },
    //             false
    //         );
    //     }
    //
    // }
    const {isLoading, formAttr, toggleCart} = useToggleCart(product, props);

    if (product.type === 'subscription') {
        if(appTheme === "manager"){
            button = <CartAnmButton onToggleCart={toggleCart} formAttr={formAttr} isLoading={isLoading} />;
        } else {
            if (product.included_in_pkg !== "not_included" &&
                (hasOwnedPckg || hasOwnedPckgInfo)
            ){
                button = <SubscribeFreeButton product={product}/>
            } else {
                button = <SubscribeButton product={product} type={'subscription'}/>;
            }
        }

    } else {
        // button = <AddToCartButton product={product}/>;
        if(appTheme === 'services'){
            button = <CartButton product={product} />;
        } else if(appTheme === 'manager'){
            button = <CartAnmButton onToggleCart={toggleCart} formAttr={formAttr} isLoading={isLoading} />;
        }
    }
    return (
        <React.Fragment>
            { product.type === "consumable" &&
            <div>{ product.hasOwnProperty("number_of_items") &&
            product.number_of_items > 0 && <p className="text-center product-number-items">{ gettext("You already own") + " " + product.number_of_items + " " + gettext("credits")}</p> }
                <p className='text-center product-number-items'>{ gettext("You can add more credits from the cart.") }</p>
            </div>
            }
            {button}
        </React.Fragment>
    )
};

export default AddonButton;
